module.exports = __webpack_public_path__ + "static/media/letterIcon.33583f60.svg";